import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pay-monthly-form',
  templateUrl: './pay-monthly-form.component.html',
  styleUrls: ['./pay-monthly-form.component.css']
})
export class PayMonthlyFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/payroll/organisation-profile/pay-mothly-details/pay-monthly-form/pay-monthly-form.component.ts